import { render, staticRenderFns } from "./WorkSuccessChannels.vue?vue&type=template&id=c268f112&"
import script from "./WorkSuccessChannels.vue?vue&type=script&lang=js&"
export * from "./WorkSuccessChannels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports